import { createStyles } from 'antd-style'

import { EaBidIcon } from '@eastcoal/icon/EaBidIcon'

import { FloorBlock } from '../../../components/FloorBlock'

import { AnnouncementTabs } from './Announcement'
import { PriceIndexChartCard } from './PriceIndexChart'
import { TradeRankingCard } from './Ranking'
import { TradeSessionCard } from './TradeSession'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0,1fr) 400px',
    gridTemplateRows: '320px auto',
    rowGap: token.padding,
    paddingBlockEnd: token.padding
  }
}))

export const TradeBoardFloor = () => {
  const { styles } = useStyles()

  return (
    <FloorBlock
      icon={<EaBidIcon />}
      title='竞价交易'
      classNames={{
        body: styles.container
      }}
    >
      <AnnouncementTabs />
      <PriceIndexChartCard />
      <TradeSessionCard />
      <TradeRankingCard />
    </FloorBlock>
  )
}
